module.exports = __webpack_public_path__ + "static/media/stilly11.f4d2e0c5.JPG";